import { useState } from 'react';
import { Button } from '@mui/material';
import ApiService from '../../../../../../components/apiService/ApiService';
import CustomModal from '../../../../../../components/ui/CustomModal/customModal';
import CustomSnackbar from "../../../../../../components/ui/CustomSnackbar/customSnackbar";
import styles from './SubscriptionActivation.module.css';
import parentStyles from "../../../Details/details.module.css";


const SubscriptionActivationModal = (props) => {
    const {visible, setVisible, accountId, currentPlanCurrency, plans} = props;

    const [response, setResponse] = useState({});
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [activePlan, setActivePlan] = useState(null);
    const [licenseQty, setLicenseQty] = useState({
      'plan': 0,
      'AUTODIAL': 0,
      'BROWSER CALLING': 0,
      'WHATSAPP BUSINESS': 0,
      'viewer': 0
    });
    const [isDisabled, setIsDisabled] = useState(false);

    const handleActivateSubscription = async () => {
      try {
          const licenses = {}
          Object.keys(licenseQty).forEach(key => licenses[key] = Number(licenseQty[key]))
          if(!activePlan || licenses['plan'] <=0 || Object.values(licenses).some(license => license < 0 || isNaN(license))) {
            handleFeedback({
              success: false,
              message: 'Please enter valid values for all fields'
            });
            return;
          }
          setIsDisabled(true);
          const payload = {
              licenses: licenses,
              plan_name: activePlan
          }
          const response = await ApiService.post(`api/v1/dashboard/activate-subscription/${accountId}/`, payload);
          console.log(response);
          handleFeedback(response.data);
          setVisible(false);
      } catch(err) {
          console.log(err?.response?.data);
          handleFeedback(err?.response?.data);
      } finally {
        setIsDisabled(false);
      }
    }

    const handleCancelSubsActivation = () => {
        setActivePlan(null);
        setVisible(false);
        setLicenseQty({
          'plan': 0,
          'AUTODIAL': 0,
          'BROWSER CALLING': 0,
          'WHATSAPP BUSINESS': 0,
          'viewer': 0
        });
    }

    const handleFeedback = (response) => {
      console.log(response);
      if (response?.success) {
        setResponse(response);
      } else {
        setResponse({
          message: response.message,
          success: false,
        });
      }
      setShowSnackbar(true);
    };

    const handleLicenseQtyChange = (e) => {
        setLicenseQty(prev => ({
        ...prev,
        [e.target.name]: e.target.value
        }));
    }

    return (
      <>
        <CustomModal
            heading="Activate subscription"
            visible={visible}
            closeModal={() => setVisible(false)}
            bodyStyles={{
              width: "380px",
              padding: "2em",
            }}
            body={
              <div>
                <div className={styles.container}>
                  <form className={styles.form}>
                    <div className={parentStyles.property}>
                      <label>Plan</label>
                      <select
                        value={activePlan || ''}
                        onChange={(e) => {
                          setActivePlan(e.target.value)
                        }}
                      >
                      <option value="" disabled hidden>None</option>
                      {
                        plans.filter(plan => (currentPlanCurrency ? plan.includes(currentPlanCurrency) : true) && !plan.toLowerCase().includes('trial'))
                        .map(plan => <option value={plan}>{plan}</option>)
                      }
                      </select>
                    </div>
                    <div className={styles.inputGroup}>
                      <label htmlFor="plan">Plan licenses</label>
                      <input min={0} type="number" id="plan" name="plan" className={styles.input} value={licenseQty.plan} onChange={handleLicenseQtyChange}/>
                    </div>
                    {(currentPlanCurrency === "INR" || (!currentPlanCurrency && activePlan?.includes("INR"))) && <div className={styles.inputGroup}>
                      <label htmlFor="browserCalling">Browser calling licenses</label>
                      <input min={0} type="number" id="browserCalling" name="BROWSER CALLING" className={styles.input} value={licenseQty['BROWSER CALLING']} onChange={handleLicenseQtyChange}/>
                    </div>}
                    <div className={styles.inputGroup}>
                      <label htmlFor="autodial">Autodial licenses</label>
                      <input min={0} type="number" id="autodial" name="AUTODIAL" className={styles.input} value={licenseQty['AUTODIAL']} onChange={handleLicenseQtyChange}/>
                    </div>
                    <div className={styles.inputGroup}>
                      <label htmlFor="whatsapp business">Whatsapp business licenses</label>
                      <input min={0} type="number" id="whatsapp business" name="WHATSAPP BUSINESS" className={styles.input} value={licenseQty['WHATSAPP BUSINESS']} onChange={handleLicenseQtyChange}/>
                    </div>
                    <div className={styles.inputGroup}>
                      <label htmlFor="viewer">Viewer licenses</label>
                      <input min={0} type="number" id="viewer" name="viewer" className={styles.input} value={licenseQty.viewer}onChange={handleLicenseQtyChange}/>
                    </div>
                  </form>
                </div>
                <div className={styles.btnContainer}>
                      <Button
                        sx={{
                          margin: "30px 5px",
                          bgcolor: "#36cb64",
                          color: "white",
                          ":hover": {
                            bgcolor: "#28994B",
                          },
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        onClick={handleActivateSubscription}
                        disabled={isDisabled}
                      >
                        Activate
                      </Button>
                      <Button
                        sx={{
                          margin: "30px 5px",
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        color="success"
                        onClick={handleCancelSubsActivation}
                      >
                        Cancel
                      </Button>
                    </div>
              </div>
            }
        />
        {showSnackbar && (
          <CustomSnackbar
            setShowSnackbar={setShowSnackbar}
            message={response.message}
            type={response.success ? "success" : "error"}
            onClose={() => setShowSnackbar(false)}
          />
        )}
        </>
    )
}

export default SubscriptionActivationModal;